import DataGrid, {
  Column,
  Selection,
  FilterRow,
  Paging,
  Pager,
  // SearchPanel,
} from "devextreme-react/data-grid";

export default function TimesheetManagerTableList({
  isXSmall,
  isSmall,
  dataGrid,
  onCellPrepared,
  dataTable,
}) {
  return (
    <DataGrid
      height={document.documentElement.offsetHeight - 189}
      showBorders={true}
      showRowLines={true}
      hoverStateEnabled={true}
      rowAlternationEnabled={true}
      columnAutoWidth={true}
      columnHidingEnabled={true}
      alignment="center"
      ref={(e) => {
        dataGrid.current = e;
      }}
      dataSource={dataTable}
      className="datagrid-has-toolbar-actions"
      onCellPrepared={onCellPrepared}
    >
      {/* <SearchPanel
        visible={true}
        width={240}
        className="datagrid-toolbar-search-panel"
        placeholder="Search..."
      /> */}
      <Selection
        mode="multiple"
        selectAllMode="page"
        showCheckBoxesMode="always"
      />
      <FilterRow visible={true} />
      <Paging defaultPageSize={10} />
      <Pager
        showPageSizeSelector={true}
        allowedPageSizes={[10, 20, 50, 100]}
        showInfo={true}
        visible={true}
      />
      <Column
        caption="Employee Code"
        dataField="Employee.EmployeeCode"
        dataType="string"
        hidingPriority={isXSmall || isSmall ? 1 : false}
        fixed={isXSmall ? false : true}
        fixedPosition="left"
      />
      <Column
        caption="Employee Name"
        dataField="Employee.FullName"
        dataType="string"
        fixed={isXSmall ? false : true}
        fixedPosition="left"
      />
      <Column
        caption="Department Code"
        dataField="Employee.Department.DepartmentCode"
        dataType="string"
        hidingPriority={isXSmall ? 1 : false}
      />
      <Column
        caption="Department Code"
        dataField="Employee.Department.DepartmentName"
        dataType="string"
        hidingPriority={isXSmall ? 1 : false}
      />
      <Column
        caption="Position Name"
        dataField="Employee.Position.PositionName"
        dataType="string"
      />
      <Column
        caption="Date"
        dataField="Date"
        dataType="date"
        format="dd/MM/yyyy"
        hidingPriority={isXSmall || isSmall ? 3 : false}
      />
      <Column
        caption="Adjustment Time In"
        dataField="AdjustmentTimeIn"
        dataType="string"
      />
      <Column
        caption="Adjustment Time Out"
        dataField="AdjustmentTimeOut"
        hidingPriority={isXSmall || isSmall ? 4 : false}
      />
      <Column
        caption="Adj TimeIn Is NextDay"
        dataField="AdjTimeInIsNextDay"
        hidingPriority={isXSmall || isSmall ? 3 : false}
      />
      <Column
        caption="Adj TimeOut Is NextDay"
        dataField="AdjTimeOutIsNextDay"
        hidingPriority={isXSmall || isSmall ? 3 : false}
      />
      <Column
        caption="Adjustment Reason"
        dataField="AdjustmentReason"
        hidingPriority={isXSmall || isSmall ? 3 : false}
      />
      <Column
        caption="Explain"
        dataField="Explain"
        hidingPriority={isXSmall || isSmall ? 3 : false}
      />
      <Column
        caption="Approval Status"
        dataField="ApprovalStatus"
        hidingPriority={isXSmall || isSmall ? 3 : false}
      />
      <Column
        caption="Approved Date"
        dataField="ApprovedDate"
        dataType="date"
        format="dd/MM/yyyy"
        hidingPriority={isXSmall || isSmall ? 3 : false}
      />
      <Column
        caption="Last Approval Name"
        dataField="LastApprovalName"
        hidingPriority={isXSmall || isSmall ? 5 : false}
      />
      <Column
        caption="Approval Comments"
        dataField="ApprovalComments"
        hidingPriority={isXSmall || isSmall ? 5 : false}
      />
    </DataGrid>
  );
}
